import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import SoftUIDashboard from "./medical-hospital"
import ElementPlus from "element-plus"
import "element-plus/dist/index.css"
import VueCookies from "vue-cookies"
import print from "vue3-print-nb"

import "@fortawesome/fontawesome-free/css/all.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "bootstrap-icons/font/bootstrap-icons.css"

// Web app ile birebir eyni custom CSS
import "./assets/css/custom.css"

const app = createApp(App)

app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(VueCookies)
app.use(print)
app.use(SoftUIDashboard)

app.config.warnHandler = (msg, instance, trace) => {
  if (msg.includes('Extraneous non-props attributes (ref_key)')) return;
  console.warn(`[Vue warn]: ${msg}`, trace);
};

app.mount('#app')
